module.exports = __webpack_public_path__ + "static/media/virus.849f7d62.png";